import { takeLatest, put, call } from "redux-saga/effects";
import { actionTypes as applicationActions } from "../core/reducers/asyncInitAction";
import { initResponseService } from "./../gameservice/initResponseService";
import { initBalanceService } from "./../gameservice/initResponseService";
import { configGame, constant } from "./../data/config";

export function* initSaga(): Generator<any, any, any> {
    yield takeLatest(applicationActions.GET_APPLICATION_INIT_RESPONSE, fireInitResponse);
}

function* fireInitResponse(): Generator<any, any, any> {
    try {
        //const balanceResult = yield call(initBalanceService.sendBalanceResponse);
        const result = yield call(initResponseService.sendInitResponse);
        console.log(result);
        constant.configGame.cheatModifiedRequest = "";
        // localStorage.setItem("cheatModifiedRequest", "")
        yield put({
            type: applicationActions.GET_APPLICATION_INIT_SUCCESS,
            result
        });
        // yield put({
        //     type: applicationActions.GET_APPLICATION_INIT_BALANCE_SUCCESS,
        //     balanceResult
        // });
    } catch (error) {
        yield put({
            type: applicationActions.GET_APPLICATION_INIT_FAILURE,
            error
        });
    }
}
